import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import AnalyticsUtils from '../../../lib/AnalyticsUtils';
import ErrorFallback from '../errors/ErrorFallback';
import { ConnectionLoader } from 'new/elements/ConnectionLoader/ConnectionLoader';

const styles = { height: '100%' };

class FormPage extends React.Component {
  render() {
    const component = React.Children.only(this.props.children);
    const displayComponent = React.cloneElement(
      component,
      ['div', 'form'].includes(component.type)
        ? {}
        : {
            formData: this.props.data,
            nextFormStage: this.props.nextStage,
          },
    );

    return (
      <div style={this.props.containerStyles || styles}>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={(error, info) => {
            AnalyticsUtils.reportErrorToSentry(error, info);
          }}
        >
          {this.props.loading ? <ConnectionLoader loading /> : displayComponent}
        </ErrorBoundary>
      </div>
    );
  }
}

FormPage.defaultProps = {
  showBackButton: false,
  backButtonText: 'Back',
  nextButtons: null,
  title: '',
  contentHeight: 600,
  onEnter: null,
  disabled: false,
  disabledTooltip: null,
};

export default FormPage;
